export const environment = {
  production: false,
  environment: 'staging',
  endpoint: 'https://api-staging.offers.app.fgvalvole.com',
  sentryDSN: 'https://1624f085a7b0eb2d7291057b3907e013@sentry.monade.io/106',
  hubspot: {
    endpoint: 'https://app.hubspot.com',
    clientId: '7ec5c976-2c46-4b08-9ae5-d638888051d3',
    redirectUri: 'https://staging.offers.app.fgvalvole.com/oauth/callback',
    scope: [
      'oauth',
      'crm.objects.contacts.read',
      'crm.objects.contacts.write',
      'crm.objects.deals.write',
      'crm.objects.deals.write',
      'crm.schemas.deals.read',
      'crm.schemas.deals.write',
      'crm.objects.users.read',
      'crm.objects.users.write',
    ],
  },
};
